var map = {
	"./taro-ad-core.entry.js": [
		7738,
		7738
	],
	"./taro-ad-custom-core.entry.js": [
		5050,
		5050
	],
	"./taro-audio-core.entry.js": [
		4536,
		4536
	],
	"./taro-block-core.entry.js": [
		6915,
		6915
	],
	"./taro-button-core.entry.js": [
		7583,
		7583
	],
	"./taro-camera-core.entry.js": [
		9588,
		9588
	],
	"./taro-canvas-core.entry.js": [
		464,
		464
	],
	"./taro-checkbox-core_2.entry.js": [
		3965,
		3965
	],
	"./taro-cover-image-core.entry.js": [
		2319,
		2319
	],
	"./taro-cover-view-core.entry.js": [
		6025,
		6025
	],
	"./taro-custom-wrapper-core.entry.js": [
		4849,
		4849
	],
	"./taro-editor-core.entry.js": [
		1847,
		1847
	],
	"./taro-form-core.entry.js": [
		9141,
		9141
	],
	"./taro-functional-page-navigator-core.entry.js": [
		8455,
		8455
	],
	"./taro-icon-core.entry.js": [
		4960,
		4960
	],
	"./taro-image-core.entry.js": [
		233,
		233
	],
	"./taro-input-core.entry.js": [
		8744,
		8744
	],
	"./taro-keyboard-accessory-core.entry.js": [
		777,
		777
	],
	"./taro-label-core.entry.js": [
		7689,
		7689
	],
	"./taro-live-player-core.entry.js": [
		6286,
		6286
	],
	"./taro-live-pusher-core.entry.js": [
		6866,
		6866
	],
	"./taro-map-core.entry.js": [
		8564,
		8564
	],
	"./taro-match-media-core.entry.js": [
		3059,
		3059
	],
	"./taro-movable-area-core.entry.js": [
		4741,
		4741
	],
	"./taro-movable-view-core.entry.js": [
		4768,
		4768
	],
	"./taro-navigation-bar-core.entry.js": [
		996,
		996
	],
	"./taro-navigator-core.entry.js": [
		4915,
		5084,
		4915
	],
	"./taro-official-account-core.entry.js": [
		8811,
		8811
	],
	"./taro-open-data-core.entry.js": [
		8586,
		8586
	],
	"./taro-page-container-core.entry.js": [
		1927,
		1927
	],
	"./taro-page-meta-core.entry.js": [
		9803,
		9803
	],
	"./taro-picker-core_2.entry.js": [
		3361,
		3361
	],
	"./taro-picker-view-column-core.entry.js": [
		4225,
		4225
	],
	"./taro-picker-view-core.entry.js": [
		6323,
		6323
	],
	"./taro-progress-core.entry.js": [
		7208,
		7208
	],
	"./taro-pull-to-refresh.entry.js": [
		3443,
		5084,
		3443
	],
	"./taro-radio-core_2.entry.js": [
		4117,
		4117
	],
	"./taro-rich-text-core.entry.js": [
		5868,
		5868
	],
	"./taro-root-portal-core.entry.js": [
		2229,
		2229
	],
	"./taro-scroll-view-core.entry.js": [
		9391,
		9391
	],
	"./taro-share-element-core.entry.js": [
		4009,
		4009
	],
	"./taro-slider-core.entry.js": [
		4120,
		4120
	],
	"./taro-slot-core.entry.js": [
		9861,
		9861
	],
	"./taro-swiper-core_2.entry.js": [
		3779,
		181
	],
	"./taro-switch-core.entry.js": [
		4517,
		4517
	],
	"./taro-tabbar.entry.js": [
		3311,
		5084,
		3311
	],
	"./taro-text-core.entry.js": [
		8983,
		8983
	],
	"./taro-textarea-core.entry.js": [
		7181,
		6048
	],
	"./taro-video-control_3.entry.js": [
		7120,
		7120
	],
	"./taro-view-core.entry.js": [
		4665,
		4665
	],
	"./taro-voip-room-core.entry.js": [
		6251,
		6251
	],
	"./taro-web-view-core.entry.js": [
		5219,
		5219
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1810;
module.exports = webpackAsyncContext;